<div class="max-w-[1200px] mx-auto py-8">
  <h1 class="mb-8 text-base md:text-xl font-bold text-center"></h1>
</div>
